import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import { fetchLocalSlots } from "./localSlotsQuery";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export interface HomePageInitialData {
  suggestUserSwitch: boolean;
  redirectTo: string;
}

export const homePageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.home(),
    queryFn: async () => {
      // Home's CMS label is "homepage": the backend normalizes it to the leading-slash form
      // ("/homepage"). The literal "/" is not a resolvable label and always 404s (verified
      // against the local direct runtime for both language prefixes).
      const [envelope, localSlots] = await Promise.all([
        fetchOccPageData<PageInitialDataResult<HomePageInitialData>>("/page-data/home"),
        fetchLocalSlots("homepage"),
      ]);
      // Any local-structure failure leaves the envelope's slots untouched. On success the
      // page-scoped slots come from the local structure and the envelope only keeps its globals
      // as the shell's no-cache fallback.
      if (localSlots && envelope.status === "OK") {
        envelope.metadata.slots = [
          ...localSlots.slots,
          ...envelope.metadata.slots.filter((slot) => slot.scope === "global"),
        ];
      }
      return envelope;
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
